// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { holesky as _holesky } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the holesky chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 17000
 * Chain Name: Holesky
 * Default Block Explorer: https://holesky.etherscan.io
 * Default RPC URL: https://ethereum-holesky-rpc.publicnode.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { holesky } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: holesky,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const holesky = createCommon({
	..._holesky,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
